// ─────────────────────────────────────────────
//  Mock Data & Static Constants
// ─────────────────────────────────────────────
import {
  LayoutDashboard, Building2, Users, Layers, Network, Settings,
} from 'lucide-react';

export const INITIAL_COMPANIES = [
  {
    id: '1', name: 'Global Tech Industries', email: 'admin@globaltech.com',
    gst: '27AADCB2230M1Z2', pan: 'AADCB2230M',
    features: ['sql', 'file'], status: 'active', industry: 'Technology', size: '500-1000',
    dbType: 'PostgreSQL', dbSchema: 'public_data', targetTables: 24, docCount: 145,
    vectorSize: '1.2 GB', activeUsers: 45,
    availableTables: ['public.users', 'public.transactions', 'hr.employees', 'finance.invoices'],
    availableFiles: ['hr_policy_v2.pdf', 'benefits_guide_2024.pdf', 'q3_financial_report.pdf'],
  },
  {
    id: '2', name: 'Nexus Innovations', email: 'hello@nexus.io',
    gst: '29AAECT1142A1Z5', pan: 'AAECT1142A',
    features: ['file'], status: 'active', industry: 'Fintech', size: '50-200',
    dbType: 'None', dbSchema: 'N/A', targetTables: 0, docCount: 82,
    vectorSize: '450 MB', activeUsers: 12,
    availableTables: [], availableFiles: ['onboarding_guide.pdf', 'tech_specs.pdf'],
  },
  {
    id: '3', name: 'Stark Logistics', email: 'operations@stark.in',
    gst: '07AAACN0124B1Z9', pan: 'AAACN0124B',
    features: ['sql'], status: 'suspended', industry: 'Logistics', size: '1000+',
    dbType: 'SQL Server', dbSchema: 'stark_ops', targetTables: 156, docCount: 0,
    vectorSize: '0 MB', activeUsers: 0,
    availableTables: ['ops.fleet', 'ops.routes', 'ops.drivers'], availableFiles: [],
  },
  {
    id: '4', name: 'Acme Corporation', email: 'billing@acmecorp.com',
    gst: '11ABZPD4521K1Z1', pan: 'ABZPD4521K',
    features: ['sql', 'file'], status: 'active', industry: 'Manufacturing', size: '200-500',
    dbType: 'MySQL', dbSchema: 'acme_erp', targetTables: 42, docCount: 310,
    vectorSize: '2.4 GB', activeUsers: 28,
    availableTables: ['erp.inventory', 'erp.suppliers'],
    availableFiles: ['safety_manual.pdf', 'vendor_contracts.pdf'],
  },
];

export const INITIAL_WORKSPACES = [
  { id: 'ws1', companyId: '1', companyName: 'Global Tech Industries', name: 'Human Resources', desc: 'HR policies and employee data.',  tables: ['hr.employees'], files: ['hr_policy_v2.pdf', 'benefits_guide_2024.pdf'], status: 'active' },
  { id: 'ws2', companyId: '1', companyName: 'Global Tech Industries', name: 'Finance',          desc: 'Financial reports and invoices.', tables: ['public.transactions', 'finance.invoices'], files: ['q3_financial_report.pdf'], status: 'active' },
  { id: 'ws3', companyId: '4', companyName: 'Acme Corporation',        name: 'Operations',       desc: 'Supply chain and inventory.',     tables: ['erp.inventory', 'erp.suppliers'], files: ['safety_manual.pdf', 'vendor_contracts.pdf'], status: 'active' },
];

export const INITIAL_USERS = [
  { id: 'u1', name: 'Alice Smith',   email: 'alice@globaltech.com', phone: '+1 (555) 123-4567', company: 'Global Tech Industries', role: 'Admin', status: 'active'    },
  { id: 'u2', name: 'Bob Jones',     email: 'bob@nexus.io',          phone: '+1 (555) 987-6543', company: 'Nexus Innovations',      role: 'User',  status: 'active'    },
  { id: 'u3', name: 'Charlie Brown', email: 'charlie@stark.in',      phone: '+91 98765 43210',   company: 'Stark Logistics',        role: 'User',  status: 'suspended' },
  { id: 'u4', name: 'Diana Prince',  email: 'diana@acmecorp.com',    phone: '+1 (555) 456-7890', company: 'Acme Corporation',       role: 'Admin', status: 'active'    },
  { id: 'u5', name: 'Evan Wright',   email: 'evan@globaltech.com',   phone: '+1 (555) 222-3333', company: 'Global Tech Industries', role: 'User',  status: 'active'    },
];


export const DEFAULT_NEW_MODEL     = { name: '', provider: 'OpenAI', context: '128k', type: 'Chat', apiKey: '' };
export const DEFAULT_NEW_WORKSPACE = { companyId: '', useCaseName: '', description: '', filePromptConfiguration: '', sqlPromptConfiguration: '', useCaseDetails: [] };

export const NAV_ITEMS = [
  { id: 'dashboard',  label: 'Overview',                    icon: LayoutDashboard },
  { id: 'companies',  label: 'Companies',                   icon: Building2       },
  { id: 'users',      label: 'User Management',             icon: Users           },
  { id: 'workspaces', label: 'Workspaces',                  icon: Layers          },
  { id: 'data',       label: 'Data Sources & Integrations', icon: Network         },
  { id: 'settings',   label: 'System Settings',             icon: Settings        },
];